import http from "../http/http-config";
import { GetQuotationPersonsRelationResponse } from "../models/getQuotationPersonsRelationResponse";

export default new class getQuotationPersonsRelation {
    getQuotationPersonsRelation(productId, onDate): Promise<GetQuotationPersonsRelationResponse> {
        return http.get<GetQuotationPersonsRelationResponse>("GetQuotationPersonsRelation", {
            params: {
                productId,
                onDate
            }
        }).then(response => response.data)
    }
}